"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var helper_1 = require("lib/functions/helper");
var DataStore = (function () {
    function DataStore(json) {
        this.json = json;
    }
    DataStore.prototype.getAllStates = function () {
        var states = this.json.states;
        return states.map(function (s) {
            return { value: s.name, name: s.name };
        });
    };
    DataStore.prototype.getAdvisorsArray = function (campusName) {
        var json = this.json;
        if (json.campuses) {
            for (var i = 0; i < json.campuses.length; i++) {
                if (json.campuses[i].name == campusName) {
                    return json.campuses[i].advisors;
                }
            }
        }
        console.log("Warning! No advisers found for campus=" + campusName);
        return null;
    };
    Object.defineProperty(DataStore.prototype, "programs", {
        get: function () {
            var json = this.json;
            var programs = [];
            if (json.programs) {
                programs = json.programs;
                programs.sort(function (a, b) {
                    if (a.name < b.name)
                        return -1;
                    if (a.name > b.name)
                        return 1;
                    return 0;
                });
            }
            return programs;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "campuses", {
        get: function () {
            var json = this.json;
            var campuses = [];
            if (json.campuses) {
                campuses = json.campuses;
                campuses.sort(function (a, b) {
                    if (a.name < b.name)
                        return -1;
                    if (a.name > b.name)
                        return 1;
                    return 0;
                });
            }
            return campuses;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "marital_status", {
        get: function () {
            return [
                { value: "Married", name: "Married" },
                { value: "Single", name: "Single" },
                { value: "Divorced", name: "Divorced" },
                { value: "Widow", name: "Widow" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "gender", {
        get: function () {
            return [
                { value: "Male", name: "Male" },
                { value: "Female", name: "Female" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "yesNoOptions", {
        get: function () {
            return [
                { value: "yes", name: "Yes" },
                { value: "no", name: "No" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "schedules", {
        get: function () {
            return [
                { name: "Part time schedule", value: "Part time schedule" },
                { name: "Full time schedule", value: "Full time schedule" },
                { name: "Night time schedule", value: "Night time schedule" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "citizenship", {
        get: function () {
            return [
                { value: "us-citizen", name: "US Citizen" },
                { value: "permanent-resident", name: "Permanent Resident" },
                { value: "daca-dreamer", name: "DACA/Dreamer" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "ethnicity", {
        get: function () {
            return [
                { value: "asian", name: "Asian" },
                { value: "white", name: "White" },
                { value: "hispanic", name: "Hispanic/Latino" },
                { value: "black-african", name: "Black/African American" },
                { value: "american-indian", name: "American Indian/Alaska Native" },
                { value: "native-hawaiia", name: "Native Hawaiian/Pacific Islander" },
                { value: "two-or-more", name: "Two or more races" },
                { value: "unknown", name: "Race or Ethnicity unknown" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "planPayEducation", {
        get: function () {
            return [
                { value: "monthly-cash-payment-plans", name: "Monthly Cash Payment Plans" },
                { value: "va-gi bill", name: "VA/GI Bill" },
                { value: "federal-student-aid", name: "Federal Student Aid" },
                { value: "education-trust", name: "Education Trust/529 Plan" },
                { value: "other", name: "Other" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "relationShip", {
        get: function () {
            return [
                { value: "Parent", name: "Parent" },
                { value: "Guardian", name: "Guardian" },
                { value: "Spouse", name: "Spouse" },
                { value: "Partner", name: "Partner" },
                { value: "Medical representative", name: "Medical representative" },
                { value: "Power attorney", name: "Power attorney" },
                { value: "Family", name: "Family" },
                { value: "Other", name: "Other" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "militaryBranch", {
        get: function () {
            return [
                { value: "air_force", name: "Air Force" },
                { value: "air_force_reserve", name: "Air Force Reserve" },
                { value: "air_national_guard", name: "Air Force Guard" },
                { value: "army", name: "Army" },
                { value: "army_national_guard", name: "Army National Guard" },
                { value: "army_reserve", name: "Army Reserve" },
                { value: "coast_guard", name: "Coast Guard" },
                { value: "coast_guard_reserve", name: "Coast Guard Reserve" },
                { value: "marine_corps", name: "Marine Corps" },
                { value: "marine_corps_reserve", name: "Marine Corps Reserve" },
                { value: "navy", name: "Navy" },
                { value: "navy_reserve", name: "Navy Reserve" },
                { value: "space_force", name: "Space Force" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "countryOptions", {
        get: function () {
            var countries = this.json.newCountries;
            return countries.map(function (country) { return ({
                name: "" + country.value,
                value: "" + country.countryId + helper_1.DELIMITER + country.label + helper_1.DELIMITER + country.value + helper_1.DELIMITER + country.code
            }); });
        },
        enumerable: true,
        configurable: true
    });
    DataStore.prototype.getStatesByCountryName = function (countryInfo) {
        if (!countryInfo) {
            return [];
        }
        var countries = this.json.newCountries;
        if (countries) {
            var _a = helper_1.getPartsByDelimiter(countryInfo), countryId_1 = _a[0], label = _a[1], value = _a[2], code_1 = _a[3];
            var country = countries.filter(function (country) { return country.countryId == +countryId_1 && country.code === code_1; })[0];
            if (country) {
                return country.states.map(function (state) { return ({
                    name: state.label,
                    value: "" + state.stateId + helper_1.DELIMITER + state.label + helper_1.DELIMITER + state.value + helper_1.DELIMITER + state.countryId
                }); });
            }
            return [];
        }
        return [];
    };
    Object.defineProperty(DataStore.prototype, "educationOptions", {
        get: function () {
            return [
                { id: "education_high_school", value: "high-school", name: "High School (USA)" },
                { id: "education_ged", value: "ged", name: "GED" },
                {
                    id: "education_high_school_international",
                    value: "high-school-international",
                    name: "High School (International)"
                },
                { id: "education_home_school", value: "home-school", name: "Home School" },
                { id: "education_other", value: "other", name: "Other" },
                {
                    id: "education_still_in_high_school",
                    value: "still-in-high-school",
                    name: "Still in High School"
                }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "highSchoolOtherDetailsOptions", {
        get: function () {
            return [
                { value: "in-high-school-concurrently", name: "In High School Concurrently" },
                { value: "in-ged-concurrently", name: "In GED Concurrently" },
                { value: "currently-in-college", name: "Currently in College" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    return DataStore;
}());
exports.DataStore = DataStore;
//# sourceMappingURL=data:application/json;base64,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